import { formatTimeRange } from './dailyWorkHours';

/** Compact secondary lines for hours entry detail (reports / my hours). */
export function formatHoursEntryMeta(entry, t) {
  if (!entry) return [];
  const lines = [];
  const range = formatTimeRange(entry.startTime, entry.endTime);
  if (range) {
    lines.push(range);
  }
  if (entry.usedLunch) {
    const reduction = Number(entry.workhoursReducedForLunch) || 0;
    if (reduction > 0) {
      lines.push(t('workerHoursReport.lunchReduced', {
        defaultValue: 'Lunch (−{{hours}} h)',
        hours: reduction,
      }));
    } else {
      lines.push(t('workerHoursReport.lunchUsed', { defaultValue: 'Lunch used' }));
    }
  }
  if (entry.notes) {
    lines.push(entry.notes);
  }
  return lines;
}
